export default function Drawer({children}) {
  return children;
}

Drawer.type = Symbol('MiniVariantDrawer.Drawer');
